@import 'styles/variables';
@import 'styles/mixins';
@import 'styles/blaze/mixins';

.container {
  display: flex;
  flex-direction: column;
  gap: 25px;
  width: 100%;
  max-width: 520px;
  align-items: center;
  margin: 0 auto;
  justify-content: start;

  @include for-phone-only {
    padding: 0 20px;
  }

  @include for-small-desktop-up {
    gap: 36px;
    justify-content: center;
  }
}

.title {
  @include xxxl-sohne;
  color: var(--dark-80);
  text-align: center;

  @include for-phone-only {
    /* H1 Mobile */
    font-family: Sohne;
    font-size: 30px;
    font-style: normal;
    font-weight: 600;
    line-height: 110%; /* 33px */
  }
}

.alreadyHaveAccount {
  text-align: center;
  font-family: Sohne;
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  color: var(--dark-80);

  .login {
    @include md-sohne;
    color: var(--selected-fill);
  }
}

.buttons {
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  max-width: 420px;

  @include for-small-desktop-up {
    width: 320px;
  }
}

.oauthButton {
  margin-bottom: 0.75rem;
}

.emailForm {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 15px;
}

.emailField {
  position: relative;
  width: 100%;

  .emailInput {
    border-radius: 10px;
  }
}

.inlineSubmitButton {
  position: absolute;
  right: 0.75rem;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
}

.errorContainer {
  margin-top: 0.5rem;
}

.mailIcon {
  margin-right: 0.5rem;
  display: flex;
  align-items: center;
}

.linkWrapperText {
  margin-top: 1.25rem;
  text-align: center;
  font-size: 0.875rem;
}

.footerText {
  text-align: center;
  @include sm-sohne;
  color: var(--dark-40);

  font-size: 12px;

  a {
    color: var(--dark-40);
  }
}

.registrationButton {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  width: 100%;
}

.logo {
  position: absolute;
  top: -90px;
  left: 50%;
  transform: translateX(-50%);
}
